import { MoreVerticalCircle01Icon } from '@/utils/icons'
import { logIn, logOut } from '@/discord/api'
import { useClientSession } from '@/discord/hooks/useFetchSession'
import React, { useState, useRef, useEffect } from 'react'

const DropdownMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { data:session, isAuthenticated, isLoading } = useClientSession()
  const dropdownRef = useRef<HTMLDivElement>(null)

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev)
  }

  const handleClickOutside = (event: MouseEvent) => {
    if ((dropdownRef.current != null) && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <div className='relative inline-block text-left' ref={dropdownRef}>
      {/* Dropdown Button */}
      <button
        onClick={toggleDropdown}
      >
        <MoreVerticalCircle01Icon width={19} />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className='origin-top-right absolute right-0  w-40 rounded-xl shadow-lg z-50 bg-bgColor'>
          <div className=' w-[95%] mx-auto mt-1' role='menu' aria-orientation='vertical'>
            <button
              onClick={() => {
                if (isAuthenticated) {
                  logOut()
                } else {
                  logIn()
                }
              }}
              className='block bg-primary text-white w-full rounded-lg text-left px-4 py-2 text-sm'
            >
              {isAuthenticated
                ? `${session?.user.username} (log out)`
                : 'login'}
            </button>
            <a
              href='https://docs.monadex.exchange/'
              className='block px-4 py-2 text-sm text-white'
              role='menuitem'
            >
              Documentation
            </a>
            <a
              href='https://x.com/Monadex_labs'
              className='block px-4 py-2 text-sm text-white'
              role='menuitem'
            >
              X
            </a>
            <a
              href='https://discord.gg/ZwGBssxNCx'
              target='_blank'
              className='block px-4 py-2 text-sm text-white'
              role='menuitem'
              rel='noreferrer'
            >
              Official Discord
            </a>
          </div>
        </div>
      )}
    </div>

  )
}

export default DropdownMenu
